import React from 'react'; // Removed useState, useEffect
import { motion } from 'framer-motion';
import { Box, Info } from 'lucide-react'; // Removed Layers
// Removed FloorPlanVisualization import
import ThreeDVisualization from './ThreeDVisualization';

/**
 * VisualizationManager component
 * Renders the 3D visualization for the mesh placement.
 *
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data (might still be needed for floor dimensions etc. in 3D view)
 * @param {Array} props.placements - Array of placement objects { type, position } for the current node count/algorithm
 * @param {number} props.nodeCount - The currently active number of nodes
 * @param {string} props.algorithm - Name of the selected algorithm
 * @param {string} props.routerStandard - The selected router standard
 * @returns {JSX.Element} VisualizationManager component
 */
const VisualizationManager = ({
  formData,
  placements, // Receive the calculated placements directly
  floorPlanLayout, // <<< Add floorPlanLayout prop
  nodeCount, // Receive the active node count
  algorithm,
  routerStandard // Pass router standard if needed by 3D viz
}) => {

  // No longer need to manage 2D/3D state or check floor count

  return (
    <div className="space-y-4"> {/* Reduced outer spacing */}
      {/* Removed the container div with shadow/border, assuming parent provides it */}
      {/* Removed the 2D/3D selector buttons */}

      {/* Info box for 3D */}
      <div className="flex items-start bg-blue-50 p-3 rounded-lg border border-blue-100">
        <Info className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-blue-700">
          <p>3D visualization shows the calculated placement of {nodeCount} node(s) using the {algorithm} algorithm.</p>
          <p className="mt-1">Use mouse controls (rotate, zoom, pan) to explore the layout.</p>
        </div>
      </div>

      {/* Always render 3D Visualization */}
      <div className="mt-4">
        {placements && placements.length > 0 ? (
          <ThreeDVisualization
            formData={formData} // Keep formData if needed for other 3D aspects
            // Pass the relevant props directly
            placements={placements}
            floorPlanLayout={floorPlanLayout} // <<< Pass floorPlanLayout down
            nodeCount={nodeCount}
            // Pass other props if ThreeDVisualization needs them
            routerStandard={routerStandard} // Pass routerStandard down
          />
        ) : (
          // Placeholder if placements aren't ready (e.g., during recalculation)
          <div className="w-full h-[400px] bg-gray-200 rounded-lg flex items-center justify-center">
            <div className="text-center">
              <Box className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-700">Loading Visualization...</h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VisualizationManager;